{ "frames": {
   "0": {
    "frame": { "x": 0, "y": 0, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "1": {
    "frame": { "x": 16, "y": 0, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 10, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "2": {
    "frame": { "x": 64, "y": 21, "w": 16, "h": 20 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 9, "w": 16, "h": 20 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "3": {
    "frame": { "x": 32, "y": 0, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "4": {
    "frame": { "x": 0, "y": 0, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "5": {
    "frame": { "x": 48, "y": 0, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 10, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "6": {
    "frame": { "x": 80, "y": 21, "w": 16, "h": 20 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 9, "w": 16, "h": 20 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "7": {
    "frame": { "x": 64, "y": 0, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "8": {
    "frame": { "x": 80, "y": 0, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "9": {
    "frame": { "x": 0, "y": 21, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 10, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "10": {
    "frame": { "x": 64, "y": 41, "w": 16, "h": 20 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 9, "w": 16, "h": 20 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "11": {
    "frame": { "x": 16, "y": 21, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "12": {
    "frame": { "x": 80, "y": 0, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "13": {
    "frame": { "x": 32, "y": 21, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 10, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "14": {
    "frame": { "x": 80, "y": 41, "w": 16, "h": 20 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 9, "w": 16, "h": 20 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "15": {
    "frame": { "x": 48, "y": 21, "w": 16, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 16, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "16": {
    "frame": { "x": 0, "y": 42, "w": 15, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 9, "y": 11, "w": 15, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "17": {
    "frame": { "x": 15, "y": 42, "w": 15, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 9, "y": 10, "w": 15, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "18": {
    "frame": { "x": 30, "y": 63, "w": 15, "h": 20 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 9, "y": 9, "w": 15, "h": 20 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "19": {
    "frame": { "x": 45, "y": 63, "w": 15, "h": 20 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 9, "y": 11, "w": 15, "h": 20 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "20": {
    "frame": { "x": 0, "y": 42, "w": 15, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 9, "y": 11, "w": 15, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "21": {
    "frame": { "x": 30, "y": 42, "w": 15, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 9, "y": 10, "w": 15, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "22": {
    "frame": { "x": 60, "y": 82, "w": 15, "h": 20 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 9, "y": 9, "w": 15, "h": 20 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "23": {
    "frame": { "x": 45, "y": 42, "w": 15, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 9, "y": 11, "w": 15, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "24": {
    "frame": { "x": 60, "y": 61, "w": 15, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 15, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "25": {
    "frame": { "x": 75, "y": 61, "w": 15, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 10, "w": 15, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "26": {
    "frame": { "x": 75, "y": 82, "w": 15, "h": 20 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 9, "w": 15, "h": 20 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "27": {
    "frame": { "x": 0, "y": 63, "w": 15, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 15, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "28": {
    "frame": { "x": 60, "y": 61, "w": 15, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 15, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "29": {
    "frame": { "x": 15, "y": 63, "w": 15, "h": 21 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 10, "w": 15, "h": 21 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "30": {
    "frame": { "x": 30, "y": 83, "w": 15, "h": 20 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 9, "w": 15, "h": 20 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   },
   "31": {
    "frame": { "x": 45, "y": 83, "w": 15, "h": 20 },
    "rotated": false,
    "trimmed": true,
    "spriteSourceSize": { "x": 8, "y": 11, "w": 15, "h": 20 },
    "sourceSize": { "w": 32, "h": 32 },
    "duration": 100
   }
 },
 "meta": {
  "app": "https://www.aseprite.org/",
  "version": "1.3.6-x64",
  "image": "char_walk-sheet.png",
  "format": "RGBA8888",
  "size": { "w": 96, "h": 103 },
  "scale": "1",
  "frameTags": [
   { "name": "front", "from": 0, "to": 7, "direction": "forward", "color": "#000000ff" },
   { "name": "back", "from": 8, "to": 15, "direction": "forward", "color": "#000000ff" },
   { "name": "right", "from": 16, "to": 23, "direction": "forward", "color": "#000000ff" },
   { "name": "left", "from": 24, "to": 31, "direction": "forward", "color": "#000000ff" }
  ],
  "layers": [
   { "name": "Sprite Sheet", "opacity": 255, "blendMode": "normal" }
  ],
  "slices": [
  ]
 }
}
